export const SET_ALL_ORGANIZATION_PROFILE = "SET_ALL_ORGANIZATION_PROFILE";
export const SELECT_ORGANIZATION_PROFILE = "SELECT_ORGANIZATION_PROFILE";
export const REMOVE_ORGANIZATION_PROFILE = "REMOVE_ORGANIZATION_PROFILE";
export const UPDATE_ORGANIZATION_PROFILE = "UPDATE_ORGANIZATION_PROFILE";
export const ADD_ORGANIZATION_PROFILE = "ADD_ORGANIZATION_PROFILE";
export const SET_ORGANIZATION_PROFILES = "SET_ORGANIZATION_PROFILES";
export const SET_ORGANIZATION_ID = "SET_ORGANIZATION_ID";
export const SET_ORGANIZATION_METRICS_BY_ID = "SET_ORGANIZATION_METRICS_BY_ID";
export const SET_INFINITE_ORGANIZATIONS = "SET_INFINITE_ORGANIZATIONS";
export const SET_MANAGED_ORGANIZATIONS = "SET_MANAGED_ORGANIZATIONS";
export const SET_SEARCHED_MANAGED_ORGANIZATIONS =
  "SET_SEARCHED_MANAGED_ORGANIZATIONS";
export const SET_SEARCHED_ORGANIZATIONS = "SET_SEARCHED_ORGANIZATIONS";
export const RESET_STATE = "RESET_STATE";
export const SET_RISK_PROFILE = "SET_RISK_PROFILE";
export const SET_LIST_OF_STEPS = "SET_LIST_OF_STEPS";
export const SET_QUESTIONS_LIST_BY_STEP_ID = "SET_QUESTIONS_LIST_BY_STEP_ID";
export const SET_QUESTION_BY_ID = "SET_QUESTION_BY_ID";
export const GET_ORGA_DESCRIPTION = "GET_ORGA_DESCRIPTION";
export const GET_XML_DATA = "GET_XML_DATA";
